// Raised ("3D") buttons for the GRC pages: a gradient face, a darker bottom edge and a shadow.
// Hover lifts the shadow; pressing sinks the button onto its edge.
const BASE = "inline-flex items-center justify-center gap-1.5 font-semibold rounded-lg whitespace-nowrap select-none transition-all "
  + "focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 "
  + "active:translate-y-[2px] active:border-b disabled:opacity-60 disabled:cursor-not-allowed disabled:active:translate-y-0";

const SIZES = {
  xs: "px-2.5 py-1 text-xs",
  sm: "px-3.5 py-1.5 text-sm",
  md: "px-4 py-2 text-sm",
};

const TONES = {
  primary: "text-white bg-gradient-to-b from-indigo-500 to-indigo-700 border-b-[3px] border-indigo-900 shadow-md "
    + "hover:from-indigo-400 hover:to-indigo-600 hover:shadow-lg focus-visible:ring-indigo-400",
  secondary: "text-indigo-700 bg-gradient-to-b from-white to-indigo-50 border border-indigo-200 border-b-[3px] border-b-indigo-300 shadow-sm "
    + "hover:to-indigo-100 hover:border-indigo-300 hover:shadow-md focus-visible:ring-indigo-300",
  neutral: "text-gray-700 bg-gradient-to-b from-white to-gray-100 border border-gray-300 border-b-[3px] border-b-gray-400 shadow-sm "
    + "hover:to-gray-200 hover:shadow-md focus-visible:ring-gray-300",
  danger: "text-rose-700 bg-gradient-to-b from-white to-rose-50 border border-rose-200 border-b-[3px] border-b-rose-300 shadow-sm "
    + "hover:to-rose-100 hover:border-rose-300 hover:shadow-md focus-visible:ring-rose-300",
};

/** Class names for a raised button: tone primary | secondary | neutral | danger, size xs | sm | md. */
export const btn = (tone = "primary", size = "sm") => `${BASE} ${SIZES[size] || SIZES.sm} ${TONES[tone] || TONES.primary}`;
